import React from "react";

function Card2() {
  return (
    <div className="card-div2">
      <div className="emoji">🔰</div>
      <div className="emojiName">Japanese Symbol for Beginner</div>
      <div className="emoji-description">
        A yellow and green shield symbol, called a Shoshinsha Mark. Must be
        displayed by drivers in Japan for one year after they receive their
        drivers licence.
      </div>
    </div>
  );
}

export default Card2;
